import React, { useEffect, useReducer } from "react";
// import Dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_APPLICATION,
  UPDATE_APPLICATION,
  CREATE_APPLICATION,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import Utils from "services/Utils";
import { regexPatterns } from "@vocollege/app";
import { useStyles } from "./styles";
import { getOptionValues, getCertItems } from "services/Application";
// import EditDialog from "@vocollege/components/dist/EditDialog";
import UserEdit from "pages/users/UserEdit";
import { reducer } from "@vocollege/app/dist/modules/VoHelpers";

export const initialState = {
  data: null,
  openUserForm: false,
};

export default function ApplicationEdit() {
  // const router = useParams<any>();
  // const initialDate = Dayjs().format("YYYY-MM-DD");
  // const [urlValue, setUrlValue] = useState("");
  // const [title, setTitle] = useState("");
  // const [date, setDate] = useState(initialDate);
  const navigate = useNavigate();
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);

  // Methods.

  const getInitialState = () => {
    const initialState: { [key: string]: any } = {
      id: 0,
      email: "",
      firstname: "",
      lastname: "",
      category: "account_application",
      status: 2,
      responsible: null,
      comments: "",
      content: null,
    };
    return initialState;
  };

  // const getUserInitialState = () => {
  //   const userState = {
  //     email: "",
  //     name: "",
  //     firstname: "",
  //     lastname: "",
  //   };
  //   if (state.data) {
  //     userState.email = state.data.email;
  //     userState.firstname = state.data.firstname;
  //     userState.lastname = state.data.lastname;
  //   }
  //   return userState;
  // };

  const getUserInitialData = () => {
    if (!state.data) {
      return null;
    }
    let content = JSON.parse(state.data.content);
    return {
      email: state.data.email,
      firstname: state.data.firstname,
      lastname: state.data.lastname,
      gdpr: content?.gdpr,
    };
  };

  const handleRedirect = (state: any) => {
    if (Utils.redirect(state)) {
      toast.info(I18n.get.form.messages.redirecting, { autoClose: 0 });
    } else {
      navigate("/content/applications");
    }
  };

  const getPageTitle = (state: any) => {
    return `${I18n.get.application.categories[state.category]}: ${state.email}`;
  };

  const renderContentField = (fieldValue: any, data: any) => {
    let fieldData = JSON.parse(fieldValue);
    if (!fieldData) {
      return <></>;
    }
    let region = data.allGroups.find((v: any) => v.id === fieldData.region);
    let localCollege = data.allGroups.find(
      (v: any) => v.id === fieldData.local
    );
    let educator = data.allGroups.find((v: any) => v.id === fieldData.educator);

    return (
      <div>
        <Grid
          container
          spacing={2}
          sx={(theme) => ({
            marginBottom: theme.spacing(3),
          })}
        >
          <Grid item xs={12} md={4}>
            {region && (
              <div className={classes.fieldWrapper}>
                <Typography
                  variant="subtitle1"
                  component="label"
                  className={classes.fieldLabel}
                >
                  {I18n.get.group.categories.region}
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  fontStyle="italic"
                >
                  {region.title}
                </Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={12} md={4}>
            {localCollege && (
              <div className={classes.fieldWrapper}>
                <Typography
                  variant="subtitle1"
                  component="label"
                  className={classes.fieldLabel}
                >
                  {I18n.get.group.categories.local}
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  fontStyle="italic"
                >
                  {localCollege.title}
                </Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={12} md={4}>
            {educator && (
              <div className={classes.fieldWrapper}>
                <Typography
                  variant="subtitle1"
                  component="label"
                  className={classes.fieldLabel}
                >
                  {I18n.get.group.categories.educator}
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  fontStyle="italic"
                >
                  {educator.title}
                </Typography>
              </div>
            )}
          </Grid>
        </Grid>

        {fieldData?.roles && (
          <div className={classes.fieldWrapper}>
            <Typography
              variant="subtitle1"
              component="label"
              className={classes.fieldLabel}
            >
              {I18n.get.application.labels.roles}
            </Typography>
            <Typography variant="subtitle1" component="p" fontStyle="italic">
              {getOptionValues("roles", fieldData).join(" | ")}
            </Typography>
            <Typography variant="subtitle1" component="p" fontStyle="italic">
              {fieldData.role_other}
            </Typography>
          </div>
        )}

        {state?.data.category === "account_application" && (
          <>
            <div className={classes.fieldWrapper}>
              <Typography
                variant="subtitle1"
                component="label"
                className={classes.fieldLabel}
              >
                {I18n.get.application.labels.apps}
              </Typography>
              <Typography variant="subtitle1" component="p" fontStyle="italic">
                {getOptionValues("apps", fieldData).join(" | ")}
              </Typography>
            </div>

            <div className={classes.fieldWrapper}>
              <Typography
                variant="subtitle1"
                component="label"
                className={classes.fieldLabel}
              >
                {I18n.get.application.labels.certItems}
              </Typography>
              <Typography variant="subtitle1" component="p" fontStyle="italic">
                {getCertItems(fieldData.cert_items).join(" | ")}
              </Typography>
            </div>
          </>
        )}

        {state?.data.category === "metodmaterial" && (
          <>
            <div className={classes.fieldWrapper}>
              <Typography
                variant="subtitle1"
                component="label"
                className={classes.fieldLabel}
              >
                {I18n.get.application.labels.organisation}
              </Typography>
              <Typography variant="subtitle1" component="p" fontStyle="italic">
                {fieldData.organisation || "-"}
              </Typography>
            </div>
            <div className={classes.fieldWrapper}>
              <Typography
                variant="subtitle1"
                component="label"
                className={classes.fieldLabel}
              >
                {I18n.get.application.labels.educator}
              </Typography>
              <Typography variant="subtitle1" component="p" fontStyle="italic">
                {fieldData.educator_custom || "-"}
              </Typography>
            </div>
            <div className={classes.fieldWrapper}>
              <Typography
                variant="subtitle1"
                component="label"
                className={classes.fieldLabel}
              >
                {I18n.get.application.labels.orgnr}
              </Typography>
              <Typography variant="subtitle1" component="p" fontStyle="italic">
                {fieldData.orgnr || "-"}
              </Typography>
            </div>
            <div className={classes.fieldWrapper}>
              <Typography
                variant="subtitle1"
                component="label"
                className={classes.fieldLabel}
              >
                {I18n.get.application.labels.reference}
              </Typography>
              <Typography variant="subtitle1" component="p" fontStyle="italic">
                {fieldData.reference || "-"}
              </Typography>
            </div>
            <div className={classes.fieldWrapper}>
              <Typography
                variant="subtitle1"
                component="label"
                className={classes.fieldLabel}
              >
                {I18n.get.application.labels.billingAddress}
              </Typography>
              <Typography variant="subtitle1" component="p" fontStyle="italic">
                {fieldData.billingAddress || "-"}
              </Typography>
            </div>
            {fieldData?.other && fieldData.other.length > 0 && (
              <div className={classes.fieldWrapper}>
                <Typography
                  variant="subtitle1"
                  component="p"
                  fontStyle="italic"
                >
                  {fieldData.other.map(
                    (v: string) =>
                      I18n.get.application.metodmaterialOther.find(
                        (value: any) => {
                          return value.name === v;
                        }
                      )?.label + " - "
                  )}
                </Typography>
              </div>
            )}
          </>
        )}

        <div className={classes.fieldWrapper}>
          <Typography
            variant="subtitle1"
            component="label"
            className={classes.fieldLabel}
          >
            {I18n.get.application.labels.otherRelevantInformation}
          </Typography>
          <Typography variant="subtitle1" component="p" fontStyle="italic">
            {fieldData.description || "-"}
          </Typography>
        </div>
      </div>
    );

    // return <Alert severity="warning">{JSON.stringify(data)}</Alert>;
  };

  const getApplicationHeader = (data: any) => {
    return (
      <Grid container>
        <Grid item alignItems="center" xs={12} md>
          <Typography variant="h4" component="h2">
            {I18n.get.application.categories[data]}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          md={4}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Button
            disabled={state.openUserForm}
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => dispatch({ key: "openUserForm", values: true })}
          >
            {I18n.get.form.labels.createUser}
          </Button>
        </Grid>
      </Grid>
    );
  };

  // Effects.

  useEffect(() => {
    // setTimeout(() => {
    //   dispatch({ key: "openUserDialog", values: true });
    // }, 2000);
  }, []);

  return (
    <Layout>
      <Grid container spacing={2}>
        <Grid item xs={12} md={state.openUserForm ? 6 : 12}>
          <Form
            tabs={[
              {
                key: "content",
                label: I18n.get.misc.content,
                fields: [
                  {
                    name: "category",
                    label: "",
                    type: "custom",
                    grid: {
                      xs: 12,
                    },
                    render: (data: any) => {
                      return getApplicationHeader(data);
                    },
                  },
                  {
                    name: "email",
                    label: I18n.get.user.labels.email,
                    type: "text",
                    required: true,
                    grid: {
                      xs: 12,
                    },
                    validation: {
                      required: I18n.get.form.errors.required,
                      pattern: {
                        value: regexPatterns.email,
                        message: I18n.get.form.errors.invalidEmail,
                      },
                    },
                    params: {
                      inputProps: {
                        "data-lpignore": true,
                      },
                    },
                  },
                  {
                    name: "firstname",
                    label: I18n.get.user.labels.firstname,
                    type: "text",
                    required: true,
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    validation: {
                      required: I18n.get.form.errors.required,
                      pattern: {
                        value: regexPatterns.stringNonDigit,
                        message: I18n.get.form.errors.invalidFirstname,
                      },
                    },
                    params: {
                      inputProps: {
                        "data-lpignore": true,
                      },
                    },
                  },
                  {
                    name: "lastname",
                    label: I18n.get.user.labels.lastname,
                    type: "text",
                    required: true,
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    validation: {
                      required: I18n.get.form.errors.required,
                      pattern: {
                        value: regexPatterns.stringNonDigit,
                        message: I18n.get.form.errors.invalidLastname,
                      },
                    },
                    params: {
                      inputProps: {
                        "data-lpignore": true,
                      },
                    },
                  },
                  {
                    name: "responsible",
                    label: I18n.get.form.labels.responsible,
                    type: "entity_field",
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    params: {
                      dialog: {
                        types: ["user"],
                      },
                      fields: {
                        user: {
                          title: "name",
                        },
                      },
                    },
                  },
                  {
                    name: "status",
                    label: I18n.get.form.labels.status,
                    type: "select",
                    required: true,
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    validation: {
                      required: true,
                    },
                    params: {
                      availableValues: () => [
                        {
                          label: I18n.get.status.open,
                          value: 2,
                        },
                        {
                          label: I18n.get.status.inProgress,
                          value: 3,
                        },
                        {
                          label: I18n.get.status.closed,
                          value: 4,
                        },
                      ],
                    },
                  },
                  {
                    name: "content",
                    label: "",
                    type: "custom",
                    grid: {
                      xs: 12,
                    },
                    render: renderContentField,
                    onChange: (value, data) => {
                      console.log("value", value);
                      console.log("data", data);
                    },
                  },
                  {
                    name: "comments",
                    label: I18n.get.form.labels.comments,
                    type: "editor",
                    grid: {
                      xs: 12,
                    },
                    params: {
                      editorSettings: {
                        height: 300,
                        plugins: ["lists"],
                      },
                    },
                  },
                ],
              },
            ]}
            labels={{
              loading: I18n.get.form.labels.loadingContent,
              create: I18n.get.application.labels.createApplication,
              created: I18n.get.application.messages.applicationSaved,
              updated: I18n.get.application.messages.applicationSaved,
              deleted: I18n.get.application.messages.applicationDeleted,
              fieldRequired: I18n.get.form.errors.required,
            }}
            operations={{
              category: "application",
              get: GET_APPLICATION,
              create: CREATE_APPLICATION,
              update: UPDATE_APPLICATION,
            }}
            // variables={{ categories: ["region"] }}
            initialState={getInitialState()}
            renderPageTitle={getPageTitle}
            classes={{
              root: classes.root,
              paper: "vo-global__content-with-toolbar",
              toolbar: "vo-global__content-toolbar",
            }}
            onComplete={handleRedirect}
            onCancel={handleRedirect}
            onDataChange={(data) => dispatch({ key: "data", values: data })}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {state.openUserForm && state.data && (
            <div className={classes.formWrapper}>
              <UserEdit
                dialog
                initialData={getUserInitialData()}
                urlParams={{ id: "create" }}
                onComplete={() =>
                  dispatch({ key: "openUserForm", values: false })
                }
                onCancel={() =>
                  dispatch({ key: "openUserForm", values: false })
                }
              />
            </div>
          )}
        </Grid>
      </Grid>
    </Layout>
  );
}
